import lead from 'chimera/all/store/lead'

export default lead
